import CentratelLogo from './components/CentratelLogo.vue'
import CentratelLayout from './components/layouts/CentratelLayout.vue'

export { default as favicon } from '../img/favicon/favicon.ico?url'
export { homeDestination as logoDestination } from './navigation.js'

export default {
  Logo: CentratelLogo,
  AuthenticatedLayout: CentratelLayout,
}
